// extracted by mini-css-extract-plugin
export default {"brand-select":"brandSelection_brand-select__4OjRG"};